import { useRecoilState } from 'recoil';
import homeState from '../../atoms/home';
import messagesState from '../../atoms/messages';
import participantsState from '../../atoms/participants';
import './HomeHeader.scoped.scss';

function HomeHeader() {
  const [home, setHome] = useRecoilState(homeState);
  const [messages, setMessages] = useRecoilState(messagesState);

  const [participants] = useRecoilState(participantsState);

  return (
    <div>
      <div className="home-header">
        <i className="home-header__icon-people"></i>
        <span className="home-header__participants">👪참여자{participants.users.length}명</span>
        <ul className="home-header__buttons">
          <li>
            <button 
              className="home-header__button home-header__button--open-popup" 
              onClick={() => window.open('/chatting-app', 'Chatting App', 'width=500,height=600')} 
            />
          </li>
          <li>
            <button 
              className="home-header__button home-header__button--up-font-size" 
              onClick={() => setHome({...home, fontSize: home.fontSize + 1})} 
            />
          </li>
          <li>
            <button 
              className="home-header__button home-header__button--down-font-size" 
              onClick={() => setHome({...home, fontSize: home.fontSize === 10 ? 10 : home.fontSize - 1})} 
            />
          </li>
          <li>
            <button 
              className="home-header__button home-header__button--clear-chatting" 
              onClick={() => setMessages({
                ...messages,
                messages: []
              })} 
            />
          </li>
          <li>
            <button 
              className="home-header__button home-header__button--refresh" 
              onClick={() => window.location.reload()} 
            />
          </li>
        </ul>
      </div>
      <div className="home-menu">
        <div className={`home-menu__item ${home.menu === 'chatting' ? 'home-menu__item--active' : ''}`}>
          <button onClick={() => setHome({ ...home, menu: 'chatting' })}>광장</button>
        </div>
        <div className={`home-menu__item ${home.menu === 'rooms' ? 'home-menu__item--active' : ''}`}>
          <button onClick={() => setHome({ ...home, menu: 'rooms' })}>방목록</button>
        </div>
        <div className={`home-menu__item ${home.menu === 'members' ? 'home-menu__item--active' : ''}`}>
          <button onClick={() => setHome({ ...home, menu: 'members' })}>접속자</button>
        </div>
        <div className={`home-menu__item ${home.menu === 'notice' ? 'home-menu__item--active' : ''}`}>
          <button onClick={() => setHome({ ...home, menu: 'notice' })}>이용규정</button>
        </div>
      </div>
    </div>
  );
}

export default HomeHeader;